import {
  usePartnerSessionCanAccessModule,
  usePartnerSessionCanEditModule,
  usePartnerSessionModuleReadOnly,
} from "./usePartnerSessionPermissions";
import { PARTNER_PORTAL_PERMISSION_KEYS as PP_KEYS } from "../utils/permissions/partnerPortalPermissionKeys";

/** Partner portal View Service Catalog permission for the Services menu and its tabs. */
export function useServiceCatalogPermissions() {
  const key = PP_KEYS.VIEW_SERVICE_CATALOG;
  const canAccess = usePartnerSessionCanAccessModule(key);
  const canEdit = usePartnerSessionCanEditModule(key);
  const readOnly = usePartnerSessionModuleReadOnly(key);

  return {
    canAccess,
    canEdit,
    readOnly,
    /** View or NA: purchase and status actions cannot be used. */
    actionsLocked: readOnly || !canEdit,
  };
}
